import { useState } from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "../context/AuthContext";
import { apiErr } from "../lib/api";
import { BrandLogo } from "../components/BrandLogo";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { Loader2, ArrowLeft } from "lucide-react";

export default function AccountAuth() {
  const { login, register } = useAuth();
  const nav = useNavigate();
  const tab = "login";
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      if (tab === "login") {
        const u = await login(email.trim(), password, remember);
        toast.success(`Bentornato, ${u.name}`);
      } else {
        const u = await register(name.trim(), email.trim(), password);
        toast.success(`Benvenuto, ${u.name}`);
      }
      nav("/account");
    } catch (err) {
      toast.error(apiErr(err));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#0B0B0D] text-white flex flex-col">
      <div className="max-w-6xl mx-auto w-full px-4 h-16 flex items-center">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-white/60 hover:text-white" data-testid="account-back"><ArrowLeft size={16} /> Torna al portale</Link>
      </div>
      <div className="flex-1 flex items-center justify-center px-4 pb-16">
        <motion.div initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-sm">
          <div className="mb-6"><BrandLogo name="Pickfood" size={30} /></div>
          <h1 className="font-head text-2xl font-bold">Area clienti</h1>
          <p className="text-white/55 text-sm mb-6">Salva i tuoi ordini, indirizzi e coupon. Puoi comunque ordinare come ospite.</p>

          <form onSubmit={submit} className="space-y-4">
            {tab === "register" && (
              <div>
                <Label htmlFor="name" className="text-white/80">Nome</Label>
                <Input id="name" value={name} onChange={(e) => setName(e.target.value)} required data-testid="account-name"
                  className="h-11 mt-1 bg-white/5 border-white/10 text-white placeholder:text-white/35" placeholder="Il tuo nome" />
              </div>
            )}
            <div>
              <Label htmlFor="email" className="text-white/80">Email</Label>
              <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="account-email"
                className="h-11 mt-1 bg-white/5 border-white/10 text-white placeholder:text-white/35" placeholder="nome@esempio.it" />
            </div>
            <div>
              <Label htmlFor="password" className="text-white/80">Password</Label>
              <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="account-password"
                className="h-11 mt-1 bg-white/5 border-white/10 text-white placeholder:text-white/35" placeholder="••••••••" />
            </div>
            <Button type="submit" disabled={busy} data-testid="account-submit"
              className="w-full h-11 bg-[#FFC400] hover:bg-[#E6AC00] text-[#0B0B0D] rounded-full text-base font-semibold">
              {busy ? <Loader2 className="animate-spin" /> : (tab === "login" ? "Entra" : "Crea account")}
            </Button>
            {tab === "login" && (
              <label className="flex items-center gap-2 text-sm text-white/60 select-none cursor-pointer" data-testid="account-remember">
                <input type="checkbox" checked={remember} onChange={(e) => setRemember(e.target.checked)} className="accent-[#FFC400] w-4 h-4" />
                Ricordami su questo dispositivo
              </label>
            )}
            {tab === "login" && (
              <div className="text-center">
                <Link to="/recupera-password" className="text-sm text-[#FFC400] hover:underline" data-testid="account-forgot">Password dimenticata?</Link>
              </div>
            )}
          </form>
          <p className="text-xs text-white/40 mt-5 text-center">Non hai un account? <Link to="/registrati" className="text-[#FFC400] hover:underline" data-testid="account-goto-register">Registrati</Link></p>
          <p className="text-xs text-white/40 mt-2 text-center">Sei un partner? <Link to="/esercenti/login" className="text-[#FFC400] hover:underline">Accesso partner</Link></p>
        </motion.div>
      </div>
    </div>
  );
}
